// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7Y4DY","id":"styles_id__IPpG8"};